import { SnackbarOrigin, AlertColor } from '@mui/material';

export enum SnackBarVariant {
  /**
   * The success variant of the snackbar
   */
  Success = 'success',

  /**
   * The error variant of the snackbar
   */
  Error = 'error',

  /**
   * The warning of the variant
   */
  Warning = 'warning',

  /**
   * The info of the variant
   */
  Info = 'info',
}

export interface ISnackBar {
  /**
   * Whether to open the snackbar or not
   */
  open: boolean;

  /**
   * The message of the snackbar
   */
  message: string;

  /**
   * The variant of the snackbar
   */
  variant?: AlertColor;

  /**
   * The vertical align of the snackbar
   */
  anchorOrigin?: SnackbarOrigin;

  /**
   * The auto hide duration of the snackbar
   */
  autoHideDuration?: number;

  /**
   * The onclose handler of the snackbar
   */
  onClose?: () => void;
}
